<template>
  <div>
    <a class='ambia-item-title-link' @click='toggleOverlay'>{{ title }}</a>

    <v-overlay :value='modelOverlay' :opacity='0.75' z-index='120' @click='modelOverlay = false'>
      <v-btn
        icon
        class='model-overlay-experience-close'
        @click='toggleOverlay'
      >
        <v-icon>{{ mdiClose }}</v-icon>
      </v-btn>
      <span class='model-overlay-experience-title text-wrap'>{{ title }}</span>
      <div>
        <iframe :src='viewerUrl + "lo/" + id'
                allow='fullscreen'
                frameborder='0'
                class='overlay-experience'
                style=''
        />
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js'
import Const from '@/helpers/const'
  export default {
    name: 'OverlayModel',
    props: {
      id: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
    },
    data () {
      return {
        modelOverlay: false,
        mdiClose
      }
    },
    created() {
      this.viewerUrl = Const.AWS_CONFIG().viewerFrontEndUrl
    },
    methods: {
      toggleOverlay() {
        this.modelOverlay = !this.modelOverlay

        if (this.modelOverlay) {
          document.documentElement.style.overflowY = 'hidden'
        } else {
          document.documentElement.style.overflowY = 'scroll'
        }
      },
    }
  }
</script>
